import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useFetchWithBody, usePost } from '../../api/reactQueryCustomHooks';
import {
  Box, Button, Grid, Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, TextField, Typography, FormControl, InputLabel,
  Select, MenuItem, IconButton, InputAdornment, Popover, useMediaQuery, Chip, Alert, AlertTitle, ListSubheader,
  CircularProgress,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';

import { format } from 'date-fns';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { apiRoute, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, getModMandatory } from '../../constants/enum';
import { useSelector } from 'react-redux';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { Tab, Tabs } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { autoTable } from "jspdf-autotable"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faDownload, faDownLong, faFilter, faInfo, faRefresh, faSearch } from '@fortawesome/free-solid-svg-icons';
import { ErrorCard, LoadingCard, MainContainer, MUIDataTable, NoDataCard } from '../../components';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { head } from 'lodash';
import { toast } from 'react-toastify';

export const ALL_COLUMNS = {

  BrokerDesc: { label: "Broker", group: "broker", type: "string" },
  PartyName: { label: "Party", group: "none", type: "string" },
  Item_Name: { label: "Item", group: "none", type: "string" },
  S_Name: { label: "Shape", group: "shape", type: "string" },
  Sh_Name: { label: 'Color', group: "none", type: "string" },
  Q_Name: { label: 'Clarity', group: "none", type: "string" },
  Sz_Name: { label: 'Size', group: "none", type: "string" },
  Bill_Date: { label: "Date", group: "date", type: "date" },
  YearMonth: { label: "Month", group: "month", type: "string" },
  InvNo: { label: "InvNo", group: "none", type: "string" },
  L_Code: { label: "Lot No", group: "none", type: "string" },
  PktNo: { label: "Pkt No", group: "none", type: "string" },
  SL_Code: { label: "Mfg Lot No", group: "none", type: "string" },
  SPktNo: { label: "Mfg Pkt No", group: "none", type: "string" },
  Weight: { label: "Weight", type: "number" },
  Pcs: { label: "Pcs", type: "number" },
  Rate: { label: "Rate (₹)", rupees: true, type: "number", weighted: true },
  S_Rate: { label: "Rate ($)", dollar: true, type: "number", weighted: true },
  Amount: { label: "Amount (₹)", rupees: true, type: "number" },
  AmountD: { label: "Amount ($)", dollar: true, type: "number" },
  DiscPer: { label: "Disc %", type: "number" },
  DiscAmt: { label: "Disc Amt", type: "number" },
  NetAmtRs: { label: "Net Amt (₹)", rupees: true, type: "number" },
  NETAMTD: { label: "Net Amt ($)", dollar: true, type: "number" },
  GSTAmt: { label: "GST Amt (₹)", rupees: true, type: "number" },

  BrokAmtRs: { label: "Brokerage Amt (₹)", rupees: true, type: "number" },
  BrokAmtD: { label: "Brokerage Amt ($)", dollar: true, type: "number" },
  AftBrokNetAmtRs: { label: "Amt After Brokerage (₹)", rupees: true, type: "number" },
  AftBrokNetAmtD: { label: "Amt After Brokerage ($)", dollar: true, type: "number" },
  TDSAmt: { label: "TDS Amt (₹)", rupees: true, type: "number" },
  GST_Status: { label: "Gst Status", group: "none", type: "string" },

  LabId: { label: "Lab", group: "none", type: "string" },
  ReportNo: { label: "Report", group: "none", type: "string" },
  Cut: { label: 'Cut', group: "none", type: "string" },
  Polish: { label: 'Polish', group: "none", type: "string" },
  Symtry: { label: 'Sym', group: "none", type: "string" },
  Flrn: { label: "Flrn", group: "none", type: "string" },
  Tbl_Dpth: { label: "Depth", group: "none", type: "string" },
  Stn_Lnth: { label: "Length", group: "none", type: "string" },
  Dia: { label: 'Dia', group: "none", type: "number" },
  MsrMnt: { label: 'Measurement', group: "none", type: "string" },
  Tbl_Dptg: { label: 'Depth %', group: "none", type: "string" },
  Tbl_Ptg: { label: 'Table %', group: "none", type: "string" },
  Culet: { label: 'Culet Cond.', group: "none", type: "string" },
  Culet_Size: { label: 'Culet Size', group: "none", type: "string" },
  Grdl_Avg_Prcn: { label: 'Grdl Per', group: "none", type: "string" },
  Grdl_Cndn: { label: 'Grdl Cond.', group: "none", type: "string" },
  Grdl_Max: { label: 'Grdl Thick', group: "none", type: "string" },
  Grdl_Min: { label: 'Grdl Thin', group: "none", type: "string" },
  Pvln_Dpth: { label: 'Pvln Depth', group: "none", type: "string" },
  Plvn_Angl: { label: 'Pvln Angle', group: "none", type: "string" },
  Crwn_Hght: { label: 'Crwn Height', group: "none", type: "string" },
  Crwn_Angl: { label: 'Crwn Angle', group: "none", type: "string" },
  Category: { label: 'Growth Type', group: "none", type: "string" },
  Milky: { label: 'Milky', group: "none", type: "string" },
  Bgm: { label: 'BGM', group: "none", type: "string" },
  Pkt_Rem: { label: 'Eye Clean', group: "none", type: "string" },


};
const SngCol = ['PktNo', 'LabId', 'ReportNo', 'Cut', 'Polish', 'Symtry', 'Flrn', 'Tbl_Dpth', 'Stn_Lnth', 'Dia', 'MsrMnt', 'Tbl_Dptg', 'Tbl_Ptg', 'Culet', 'Culet_Size'
  , 'Grdl_Avg_Prcn', 'Grdl_Cndn', 'Grdl_Max', 'Grdl_Min', 'Pvln_Dpth', 'Plvn_Angl', 'Crwn_Hght', 'Crwn_Angl', 'Category', 'Milky', 'Bgm', 'Pkt_Rem'
]
const Mixcol = ['Item_Name']
export const getColumns = (groupBy, activeTab, useMktAsMfg = true, pkttype) => {
  return Object.entries(ALL_COLUMNS)
    .filter(([key, col]) => {
      // Handle SL_Code
      if (SngCol.includes(key) && pkttype == 'MIX')
        return false
      if (Mixcol.includes(key) && pkttype != 'MIX')
        return false

      if (pkttype === 'SNG' && key === "Sz_Name")
        return false
      if (key === "SL_Code") {
        if (pkttype == 'MIX')
          return false
        else {
          if (!useMktAsMfg) {
            return groupBy === "none" || groupBy === "slcode";
          } else {
            return false;
          }
        }
      }
      if (key === "L_Code") {
        if (useMktAsMfg) {
          return groupBy === "none" || groupBy === "slcode";
        }
      }
      if (key === "PartyName") {
        return groupBy === "none" || groupBy === "party";
      }
      if (key === "S_Name") {
        return groupBy === "none" || groupBy === "shape";
      }
      if (key === "SPktNo") {
        if (pkttype == 'MIX')
          return false
        else
          return !useMktAsMfg && groupBy === "none";
      }

      // Handle grouped columns
      if (col.group && col.group !== groupBy) return false;

      // Handle currency tabs
      //if (col.rupees && activeTab === "dollar") return false;
      // if (col.dollar && activeTab === "rupees") return false;

      return true;
    })
    .map(([key, col]) => ({ key, ...col }));
};
;


const TradingReport = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [tabValue, setTabValue] = useState(0);
  const [activeTab, setActiveTab] = useState('all');

  const { compCode, compName, startDate, endDate } = useSelector((state) => state.company);
  const tableRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentFilterColumn, setCurrentFilterColumn] = useState('');
  const [groupBy, setGroupBy] = useState('none');
  const [isUseMfgNoAsMktno, setIsUseMfgNoAsMktno] = useState(true)
  const [columnFilters, setColumnFilters] = useState({
    InvNo: '',
    Bill_Date: '',
    YearMonth: '',
    PartyName: '',
    L_Code: '',
    PktNo: '',
    SL_Code: '',
    SPktNo: '',
    Weight: '',
    Pcs: '',
    Rate: '',
    Amount: '',
    DiscPer: '',
    DiscAmt: '',
    NetAmtRs: '',
    GSTAmt: '',
    BrokerDesc: '',
    S_Name: '',
    GST_Status: '',
    Sh_Name: '',
    Q_Name: '',
    Sz_Name: '',
    Stn_Lnth: '',
    Dia: 0,
    LabId: '',
    ReportNo: '',
    Cut: '',
    polish: '',
    Symtry: '',
    Flrn: '',
    BrokAmtD: '',
    BrokAmtRs: '',
    AftBrokNetAmtRs: '',
    AftBrokNetAmtD: ''
  });

  const [filters, setFilters] = useState({
    compCode: compCode,
    dy: '1',
    acYear: '1',
    billType: 'S',
    acType: '13',
    Ac_id: '',
    tradeOf: '',
    Trade_Type: 'ALL',
    Pkt_Type: 'ALL',
    fromDate: dayjs(Date()).format("YYYY-MM-DD"),// startDate.split('T')[0],
    toDate: dayjs(Date()).format("YYYY-MM-DD"),//endDate.split('T')[0]//new Date()
  });

  const exportColumnKeys = [
    "InvNo",
    "Bill_Date",
    "PartyName",
    "L_Code",
    "PktNo",
    "SL_Code",
    "SPktNo",
    "Weight",
    "Pcs",
    "Rate",
    "S_Rate",
    "Amount",
    "AmountD",
    "DiscPer",
    "DiscAmt",
    "NetAmtRs",
    "NETAMTD",
    "GSTAmt",
    "TDSAmt",
    "BrokAmtRs",
    "BrokAmtD",
    "AftBrokNetAmtRs",
    "AftBrokNetAmtD"
  ];
  const exportExcelColumnKeys = [
    "InvNo",
    "Bill_Date",
    "PartyName",
    "L_Code",
    "PktNo",
    "SL_Code",
    "SPktNo",
    "Weight",
    "Pcs",
    "Rate",
    "S_Rate",
    "Amount",
    "AmountD",
    "DiscPer",
    "DiscAmt",
    "NetAmtRs",
    "NETAMTD",
    "GSTAmt",
    "TDSAmt",
    "BrokAmtRs",
    "BrokAmtD",
    "AftBrokNetAmtRs",
    "AftBrokNetAmtD"
  ];

  const { data: SaleRegTempData, mutate: filterXlTemplate } = useFetchWithBody({
    url: apiRoute.stockEntry.getExcelTemplate,
    queryKey: "funExcelTemplateStock",
    inputData: {
      tempname: 'SaleRegister'
    }
  })
 // console.log(SaleRegTempData)
  const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
    url: apiRoute.modSetting.getModSetting,
    queryKey: "fetchModSettingInwardItem",
    inputData: {
      mod_name: ENUM_MOD_NAME.GeneralSettings
    }
  })
  const saleRegTemplateColumn = useMemo(() => {
    if (SaleRegTempData && SaleRegTempData?.length > 0) {
      const column = SaleRegTempData
        .sort((a, b) => (a?.xl_col_no || 0) - (b?.xl_col_no || 0))
        .map(ele => ele?.tb_col_name || '');
      return column
    }
    else return []
  }, [SaleRegTempData])
  useEffect(() => {
    if (modSetting && modSetting.length > 0) {
      const mktSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.UseMfgNoAsMktNo, modSetting);
      setIsUseMfgNoAsMktno(mktSetting)
    }
  }, [modSetting])
  const { data: partyData = [] } = useFetchWithBody({
    url: apiRoute.salesData.getParties,
    queryKey: ['salesParties', filters.acType, filters.tradeOf],
    inputData: {
      compCode: compCode[0],
      acType: filters.acType,
      tradeOf: filters.tradeOf
    },
    enabled: !!filters.acType // Only fetch when acType has a value
  });

  const { mutate: fetchReportData, isPending: isLoading, isError, data: reportData = [], error } = usePost({
    queryKey: ['salesReport', filters],
    url: apiRoute.salesData.getData,
  });



  // Apply column filters to the data
  const filteredData = useMemo(() => {
    if (!reportData.length) return [];
    return reportData.filter(row => {
      return Object.entries(columnFilters).every(([key, value]) => {
        if (!value) return true;
        const rowValue = row[key] || '';
        return String(rowValue).toLowerCase().includes(String(value).toLowerCase());
      });
    });
  }, [reportData, columnFilters]);




  const filteredAndGroupedData = useMemo(() => {
    if (!reportData?.length) return [];

    // ---------- FILTER ----------
    // const filteredData = reportData.filter(row =>
    //   Object.entries(columnFilters).every(([key, value]) => {
    //     if (!value) return true;
    //     return String(row[key] ?? '')
    //       .toLowerCase()
    //       .includes(String(value).toLowerCase());
    //   })
    // );

    if (groupBy === 'none') return filteredData;

    // ---------- GROUP ----------
    const groupedData = {};

    const getGroupKey = (row) => {
      switch (groupBy) {
        case 'broker':
          return row.BrokerDesc || 'Unknown Broker';

        case 'date':
          return format(new Date(row.Bill_Date), 'yyyy-MM-dd');

        case 'month':
          return row.YearMonth || 'Unknown Month';

        case 'party':
          return row.PartyName || 'Unknown Party';

        case 'shape':
          return row.S_Name || 'Unknown Shape';

        case 'slcode': // MFG / LOT
          return isUseMfgNoAsMktno
            ? (row.L_Code || 'Unknown Lot')
            : (row.SL_Code || 'Unknown Lot');

        default:
          return 'all';
      }
    };

    const initGroup = (row, key) => ({
      groupKey: key,

      Bill_Date:
        groupBy === 'date'
          ? format(new Date(row.Bill_Date), 'dd-MMM-yyyy')
          : key,

      YearMonth:
        groupBy === 'month'
          ? row.YearMonth
          : key,

      PartyName:
        groupBy === 'party'
          ? row.PartyName
          : 'Multiple Parties',

      BrokerDesc:
        groupBy === 'broker'
          ? row.BrokerDesc
          : 'Multiple Brokers',

      S_Name:
        groupBy === 'shape'
          ? row.S_Name
          : 'Multiple Shape',

      SL_Code: row.SL_Code || 'N/A',
      L_Code: row.L_Code || 'N/A',

      PktNo: 0,
      Weight: 0,
      Pcs: 0,
      Rate: 0,
      S_Rate: 0,
      Amount: 0,
      AmountD: 0,
      DiscPer: 0,
      DiscAmt: 0,

      // 🔥 NET VALUES
      NetAmtRs: 0,
      NETAMTD: 0,
      GSTAmt: 0,
      BrokAmtD: 0,
      BrokAmtRs: 0,
      AftBrokNetAmtRs: 0,
      AftBrokNetAmtD: 0,

      TDSAmt: 0,

      // helpers
      _rateWeightedSum: 0,
      _sRateWeightedSum: 0,
      _discCount: 0,

      // bill tracker (only for non-lot grouping)
      _billSet: new Set(),

      _children: []
    });

    filteredData.forEach(row => {
      const key = getGroupKey(row);

      if (!groupedData[key]) {
        groupedData[key] = initGroup(row, key);
      }

      const group = groupedData[key];

      const add = (field) => {
        group[field] += Number(row[field]) || 0;
      };

      add('PktNo');
      add('Weight');
      add('Pcs');
      add('Amount');
      add('AmountD');
      add('DiscAmt');
      add('GSTAmt');
      add('NetAmtRs');
      add('NETAMTD');
      add('BrokAmtRs');
      add('BrokAmtD');
      add('AftBrokNetAmtRs');
      add('AftBrokNetAmtD')

      group.TDSAmt += Number(row.TDSAmt) || 0;


      // weighted rates
      group._rateWeightedSum +=
        (Number(row.Rate) || 0) * (Number(row.Weight) || 0);

      group._sRateWeightedSum +=
        (Number(row.S_Rate) || 0) * (Number(row.Weight) || 0);

      // average discount %
      if (row.DiscPer != null) {
        group.DiscPer =
          (group.DiscPer * group._discCount + Number(row.DiscPer)) /
          (group._discCount + 1);
        group._discCount += 1;
      }

      group._children.push(row);
    });

    // ---------- FINALIZE ----------
    return Object.values(groupedData)
      .map(({ _discCount, _rateWeightedSum, _sRateWeightedSum, _billSet, ...rest }) => ({
        ...rest,
        Rate: rest.Weight ? _rateWeightedSum / rest.Weight : 0,
        S_Rate: rest.Weight ? _sRateWeightedSum / rest.Weight : 0
      }))
      .sort((a, b) => {
        if (groupBy === 'date' || groupBy === 'month') {
          return new Date(a.Bill_Date) - new Date(b.Bill_Date);
        }
        return String(a.groupKey).localeCompare(String(b.groupKey));
      });

  }, [filteredData, columnFilters, groupBy, isUseMfgNoAsMktno]);



  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };



  const handleSubmit = (e) => {
    e.preventDefault();
    if ((filters.fromDate && filters.fromDate == 'Invalid Date')
      || (filters.toDate && filters.toDate == 'Invalid Date')) {
      toast.error("Invalid From Date / To Date", {
        "position": "top-center"
      })
    }
    else {
      const params = {
        ...filters,
        fromDate: filters.fromDate && filters.fromDate != null && filters.fromDate != 'Invalid Date'
          ? filters.fromDate
          : '',
        toDate: filters.toDate && filters.toDate != null && filters.toDate != 'Invalid Date'
          ? filters.toDate //format(filters.toDate, 'yyyy-MM-dd')
          : ''
      };
      fetchReportData({ data: params });
    }

    // refetch();
  };

  const handleReset = () => {
    setFilters({
      compCode: compCode.join(","),
      dy: '1',
      acYear: '1',
      billType: 'S',
      acType: '13',
      Ac_id: '',
      tradeOf: '',
      Trade_Type: 'ALL',
      Pkt_Type: 'ALL',
      fromDate: dayjs(new Date()).format("YYYY-MM-DD"),//startDate,// new Date(new Date().setDate(new Date().getDate() - 30)),
      toDate: dayjs(new Date()).format("YYYY-MM-DD")//endDate//new Date()
    });
    const params = {
      compCode: compCode.join(","),
      dy: '1',
      acYear: '1',
      billType: 'S',
      acType: '13',
      Ac_id: '',
      tradeOf: '',
      Trade_Type: 'ALL',
      Pkt_Type: 'ALL',
      fromDate: dayjs(new Date()).format("YYYY-MM-DD"),// startDate.split('T')[0],
      toDate: dayjs(new Date()).format("YYYY-MM-DD"),//endDate.split('T')[0]//new Date()
    };
    fetchReportData({ data: params });
  };



  // const calculateTotals = () => {
  //   const totals = {
  //     PktNo: 0,
  //     Weight: 0,
  //     Rate: 0,
  //     S_Rate: 0,
  //     Amount: 0,
  //     AmountD: 0,
  //     DiscAmt: 0,
  //     NetAmtRs: 0,
  //     NETAMTD: 0,
  //     GSTAmt: 0,
  //     TDSAmt: 0
  //   };

  //   filteredData.forEach(row => {
  //     totals.PktNo += parseFloat(row.PktNo) || 0;
  //     totals.Weight += parseFloat(row.Weight) || 0;
  //     totals.Rate += parseFloat(row.Rate) || 0;
  //     totals.S_Rate += parseFloat(row.S_Rate) || 0;
  //     totals.Amount += parseFloat(row.Amount) || 0;
  //     totals.AmountD += parseFloat(row.AmountD) || 0;
  //     totals.DiscAmt += parseFloat(row.DiscAmt) || 0;
  //     totals.NetAmtRs += parseFloat(row.NetAmtRs || 0) || 0;
  //     totals.NETAMTD += parseFloat(row.NETAMTD || 0) || 0;
  //     totals.GSTAmt += parseFloat(row.GSTAmt) || 0;
  //     totals.TDSAmt += parseFloat(row.TDSAmt) || 0;
  //   });

  //   return totals;
  // };


  //const totals = calculateTotals();

  const getReportTitle = () => {
    switch (filters.billType) {
      case 'S': return 'Sales Report';
      case 'P': return 'Purchase Report';
      case 'T': return 'Sales Return Report';
      case 'N': return 'Purchase Return Report';
      default: return 'Report';
    }
  };

  const getTradeTypeLabel = () => {
    switch (filters.tradeOf) {
      case 'R': return 'Rough';
      case 'P': return 'Polish';
      case 'J': return 'Rejection';
      case 'U': return 'Non Makeable';
      default: return 'All Types';
    }
  };

  const safeDate = (val) => {
    const d = dayjs(val);
    return d.isValid() ? d : null;
  };
  const gridStyle = {
    flexBasis: {
      xs: '100%',
      sm: '50%',
      md: '25%',
      lg: '20%'
    },
    maxWidth: {
      xs: '100%',
      sm: '50%',
      md: '25%',
      lg: '20%'
    }
  }

  const headCssStyle = { fontSize: "0.7rem", lineHeight: 1.3, textTransform: "uppercase", backgroundColor: '#f0f0f0', fontWeight: 600, color: '#3c3c3c' }
  const columns = useMemo(() => getColumns(groupBy, activeTab, isUseMfgNoAsMktno, filters.Pkt_Type), [isUseMfgNoAsMktno, groupBy, filters.Pkt_Type]);


  if (isError) {
    return <ErrorCard />
  }
  if (isLoading) {
    return <LoadingCard />
  }
  return (
    <MainContainer
      pageName={`Trading Report`}
      breadcrumbs={["Reports", "Trading Report"]}

    >
      <Box sx={{
        p: isMobile ? 1 : 1,
        backgroundColor: 'background.default',
        minHeight: '100vh',

      }}>
        {/* Header Section */}

        <Box
          sx={{
            position: "relative",

            display: "flex",

            flexDirection: {
              xs: "column",
              md: "row",
            },

            justifyContent: "space-between",

            alignItems: {
              xs: "flex-start",
              md: "center",
            },

            gap: 1.5,

            mb: 1.2,

            px: {
              xs: 1.3,
              sm: 1.6,
            },

            py: {
              xs: 0.9,
              sm: 1,
            },

            minHeight: 44,

            overflow: "hidden",

            background:
              "#FFFFFF",

            border: "1px solid #bae6fd",

            borderRadius: "8px",

            boxShadow:
              "0 1px 4px rgba(14, 116, 144, 0.08)",

            transition:
              "all 0.2s ease",

            "&:hover": {
              borderColor: "#7dd3fc",

              boxShadow:
                "0 2px 7px rgba(14, 116, 144, 0.10)",
            },

            // Left accent
            "&::before": {
              content: '""',

              position: "absolute",

              left: 0,
              top: 0,
              bottom: 0,

              width: "4px",

              background:
                "linear-gradient(180deg, #0284c7, #2563eb)",
            },
          }}
        >
          {/* ==============================
        REPORT TITLE
    =============================== */}

          <Box
            sx={{
              display: "flex",

              alignItems: "center",

              minWidth: 0,

              pl: 0.5,
            }}
          >
            {/* Title Indicator */}
            <Box
              sx={{
                width: 6,
                height: 6,

                flexShrink: 0,

                mr: 1,

                borderRadius: "50%",

                backgroundColor: "#2563eb",

                boxShadow:
                  "0 0 0 3px rgba(37, 99, 235, 0.10)",
              }}
            />

            <Typography
              variant="h4"
              sx={{
                fontSize: {
                  xs: "0.9rem",
                  sm: "0.95rem",
                  md: "1rem",
                },

                fontWeight: 600,

                color: "#0f3fa8",

                letterSpacing: "-0.2px",

                lineHeight: 1.3,

                whiteSpace: {
                  xs: "normal",
                  md: "nowrap",
                },

                overflow: "hidden",

                textOverflow: "ellipsis",
              }}
            >
              {getReportTitle()}
            </Typography>
          </Box>

          {/* ==============================
        RIGHT SIDE ACTIONS
    =============================== */}


        </Box>



        {/* Filters Section */}
        <div className='p-5'>
          <form onSubmit={handleSubmit}>

            <Grid
              container
              spacing={1.5}
              alignItems="center"
              sx={{
                mb: 1.5,
                p: { xs: 1.2, sm: 1.5 },

                borderRadius: "10px",

                background:
                  "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",

                border: "1px solid #e2e8f0",

                boxShadow:
                  "0 2px 8px rgba(15, 23, 42, 0.05)",

                // ================================
                // Common Form Styling
                // ================================
                "& .MuiFormControl-root": {
                  width: "100%",
                },

                "& .MuiOutlinedInput-root": {
                  height: 38,
                  borderRadius: "7px",

                  backgroundColor: "#ffffff",

                  fontSize: "13px",

                  transition: "all 0.2s ease",

                  "& fieldset": {
                    borderColor: "#cbd5e1",
                    transition:
                      "border-color 0.2s ease, box-shadow 0.2s ease",
                  },

                  "&:hover fieldset": {
                    borderColor: "#94a3b8",
                  },

                  "&.Mui-focused": {
                    backgroundColor: "#ffffff",
                  },

                  "&.Mui-focused fieldset": {
                    borderColor: "#2563eb",
                    borderWidth: "1.5px",

                    boxShadow:
                      "0 0 0 2px rgba(37, 99, 235, 0.08)",
                  },

                  "&.Mui-disabled": {
                    backgroundColor: "#f1f5f9",
                  },
                },

                // ================================
                // Labels
                // ================================
                "& .MuiInputLabel-root": {
                  fontSize: "14px",
                  fontWeight: 700,
                  color: "#475569",
                },

                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#2563eb",
                  fontWeight: 600,
                },

                // ================================
                // Select Value
                // ================================
                "& .MuiSelect-select": {
                  display: "flex",
                  alignItems: "center",

                  minHeight: "38px !important",

                  paddingTop: "0 !important",
                  paddingBottom: "0 !important",

                  fontSize: "13px",
                  color: "#334155",
                },

                // ================================
                // TextField
                // ================================
                "& .MuiInputBase-input": {
                  fontSize: "13px",
                  color: "#334155",
                },

                // ================================
                // Autocomplete
                // ================================
                "& .MuiAutocomplete-input": {
                  padding:
                    "4px 6px !important",
                },

                "& .MuiAutocomplete-endAdornment": {
                  right: "8px",
                },

                // ================================
                // DatePicker
                // ================================
                "& .MuiPickersInputBase-root": {
                  height: 38,
                  borderRadius: "7px",
                  backgroundColor: "#ffffff",
                },

                "& .MuiPickersOutlinedInput-notchedOutline": {
                  borderColor: "#cbd5e1",
                },

                "& .MuiPickersInputBase-root:hover .MuiPickersOutlinedInput-notchedOutline":
                {
                  borderColor: "#94a3b8",
                },

                "& .MuiPickersInputBase-root.Mui-focused .MuiPickersOutlinedInput-notchedOutline":
                {
                  borderColor: "#2563eb",
                  borderWidth: "1.5px",
                },
              }}
            >
              {/* =====================================================
        1. BILL TYPE
    ====================================================== */}

              <Grid item xs={12} sm={6} md={3} lg={2.4}>
                <FormControl fullWidth size="small">
                  <InputLabel
                    sx={{
                      fontWeight: 500,
                    }}
                  >
                    Bill Type
                  </InputLabel>

                  <Select
                    name="billType"
                    value={filters.billType}
                    label="Bill Type"
                    onChange={(e) => {
                      const val = e.target.value;

                      let acType = "";

                      if (val === "S")
                        acType = "13";
                      else if (val === "P")
                        acType = "11";
                      else if (val === "T")
                        acType = "14";
                      else if (val === "N")
                        acType = "12";

                      setFilters((prev) => ({
                        ...prev,
                        billType: val,
                        acType,
                      }));
                    }}
                    sx={{
                      backgroundColor:
                        "rgba(245, 158, 11, 0.06)",

                      "&:hover": {
                        backgroundColor:
                          "rgba(245, 158, 11, 0.10)",
                      },
                    }}
                  >
                    <MenuItem value="S">
                      Sales
                    </MenuItem>

                    <MenuItem value="P">
                      Purchase
                    </MenuItem>

                    <MenuItem value="T">
                      Sales Return
                    </MenuItem>

                    <MenuItem value="N">
                      Purchase Return
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* =====================================================
        2. TRADE OF
    ====================================================== */}

              <Grid item xs={12} sm={6} md={3} lg={2.4}>
                <FormControl fullWidth size="small">
                  <InputLabel sx={{ fontSize: "12px !important", fontWeight: 200 }}>
                    Trade Of
                  </InputLabel>

                  <Select
                    name="tradeOf"
                    value={filters.tradeOf}
                    onChange={handleFilterChange}
                    label="Trade Of"
                  >
                    <MenuItem value="">
                      None
                    </MenuItem>

                    <MenuItem value="R">
                      Rough
                    </MenuItem>

                    <MenuItem value="P">
                      Polish
                    </MenuItem>

                    <MenuItem value="J">
                      Rejection
                    </MenuItem>

                    <MenuItem value="U">
                      Non Makeable
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* =====================================================
        3. ACCOUNT
    ====================================================== */}

              <Grid item xs={12} sm={6} md={3} lg={2.4}>
                <FormControl fullWidth size="small">
                  <InputLabel sx={{ fontSize: "12px !important", fontWeight: 200 }}>
                    Account
                  </InputLabel>

                  <Select
                    value={filters.Ac_id || ""}
                    onChange={(e) =>
                      setFilters((prev) => ({
                        ...prev,
                        Ac_id: e.target.value,
                      }))
                    }
                    label="Account"
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>

                    {partyData.map((p) => (
                      <MenuItem
                        key={p.AC_ID}
                        value={p.AC_ID}
                      >
                        {p.AC_DESC}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* =====================================================
        4. TRADE TYPE
    ====================================================== */}

              <Grid item xs={12} sm={6} md={3} lg={2.4}>
                <FormControl fullWidth size="small">
                  <InputLabel>
                    Trade Type
                  </InputLabel>

                  <Select
                    name="Trade_Type"
                    value={
                      filters.Trade_Type ||
                      "ALL"
                    }
                    onChange={handleFilterChange}
                    label="Trade Type"
                  >
                    <MenuItem value="ALL">
                      All
                    </MenuItem>

                    <MenuItem value="EXPORT/IMPORT">
                      Export / Import
                    </MenuItem>

                    <MenuItem value="Local">
                      Local
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* =====================================================
        5. PACKET TYPE
    ====================================================== */}

              <Grid item xs={12} sm={6} md={3} lg={2.4}>
                <FormControl fullWidth size="small">
                  <InputLabel>
                    Packet Type
                  </InputLabel>

                  <Select
                    name="Pkt_Type"
                    value={
                      filters.Pkt_Type ||
                      "ALL"
                    }
                    onChange={handleFilterChange}
                    label="Packet Type"
                    sx={{
                      backgroundColor:
                        "rgba(37, 99, 235, 0.05)",

                      "&:hover": {
                        backgroundColor:
                          "rgba(37, 99, 235, 0.08)",
                      },
                    }}
                  >
                    <MenuItem value="ALL">
                      All
                    </MenuItem>

                    <MenuItem value="SNG">
                      Single
                    </MenuItem>

                    <MenuItem value="MIX">
                      Mix
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* =====================================================
        6. FROM DATE
    ====================================================== */}

              <Grid item xs={12} sm={6} md={3} lg={2.4}>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    label="From Date"
                    format="DD/MM/YYYY"
                    views={[
                      "day",
                      "month",
                      "year",
                    ]}
                    value={
                      filters.fromDate
                        ? dayjs(
                          filters.fromDate
                        )
                        : null
                    }
                    onChange={(val) =>
                      setFilters((prev) => ({
                        ...prev,
                        fromDate: val
                          ? dayjs(
                            val
                          ).format(
                            "YYYY-MM-DD"
                          )
                          : null,
                      }))
                    }
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,

                        InputLabelProps: {
                          sx: {
                            fontSize:
                              "14px",
                            fontWeight: 500,
                          },
                        },
                      },

                      popper: {
                        placement:
                          "bottom-start",
                        disablePortal:
                          false,

                        sx: {
                          zIndex: 99999,
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>

              {/* =====================================================
        7. TO DATE
    ====================================================== */}

              <Grid item xs={12} sm={6} md={3} lg={2.4}>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    label="To Date"
                    format="DD/MM/YYYY"
                    views={[
                      "day",
                      "month",
                      "year",
                    ]}
                    value={
                      filters.toDate
                        ? dayjs(
                          filters.toDate
                        )
                        : null
                    }
                    onChange={(val) =>
                      setFilters((prev) => ({
                        ...prev,
                        toDate: val
                          ? dayjs(
                            val
                          ).format(
                            "YYYY-MM-DD"
                          )
                          : null,
                      }))
                    }
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,

                        InputLabelProps: {
                          sx: {
                            fontSize:
                              "14px",
                            fontWeight: 500,
                          },
                        },
                      },

                      popper: {
                        placement:
                          "bottom-start",
                        disablePortal:
                          false,

                        sx: {
                          zIndex: 99999,
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>

              {/* =====================================================
        8. GROUP BY
    ====================================================== */}

              <Grid item xs={12} sm={6} md={3} lg={2.4}>
                <FormControl fullWidth size="small">
                  <InputLabel>
                    Group By
                  </InputLabel>

                  <Select
                    value={groupBy}
                    onChange={(e) =>
                      setGroupBy(
                        e.target.value
                      )
                    }
                    label="Group By"
                  >
                    <MenuItem value="none">
                      Report Detail
                    </MenuItem>

                    <MenuItem value="broker">
                      Broker
                    </MenuItem>

                    <MenuItem value="date">
                      Date
                    </MenuItem>

                    <MenuItem value="month">
                      Month
                    </MenuItem>

                    <MenuItem value="party">
                      Party
                    </MenuItem>

                    <MenuItem value="shape">
                      Shape
                    </MenuItem>

                    <MenuItem value="slcode">
                      {isUseMfgNoAsMktno
                        ? "LOT NO"
                        : "MFG LOT NO"}
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* =====================================================
        9. SEARCH BUTTON
    ====================================================== */}

              <Grid item xs={12} sm={6} md={3} lg={2.4}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",

                    justifyContent: {
                      xs: "stretch",
                      sm: "flex-start",
                    },

                    height: "100%",
                  }}
                >
                  <Button
                    variant="contained"
                    type="submit"
                    disabled={isLoading}
                    size="small"
                    startIcon={
                      isLoading ? (
                        <CircularProgress
                          size={15}
                          color="inherit"
                        />
                      ) : (
                        <FontAwesomeIcon
                          icon={faSearch}
                          style={{
                            fontSize:
                              "12px",
                          }}
                        />
                      )
                    }
                    sx={{
                      width: {
                        xs: "100%",
                        sm: "100%",
                      },

                      minWidth: {
                        xs: "100%",
                        sm: "100%",
                      },

                      height: 36,

                      borderRadius: "7px",

                      fontSize: "12px",
                      fontWeight: 600,

                      textTransform: "none",

                      background:
                        "linear-gradient(135deg, #2563eb, #1d4ed8)",

                      boxShadow:
                        "0 2px 5px rgba(37,99,235,.20)",

                      "&:hover": {
                        background:
                          "linear-gradient(135deg, #1d4ed8, #1e40af)",

                        boxShadow:
                          "0 4px 9px rgba(37,99,235,.25)",

                        transform:
                          "translateY(-1px)",
                      },

                      "&:active": {
                        transform:
                          "translateY(0)",
                      },

                      "&.Mui-disabled": {
                        background:
                          "#93c5fd",
                      },
                    }}
                  >
                    {isLoading
                      ? "Searching"
                      : "SHOW"}
                  </Button>
                </Box>
              </Grid>

              {/* =====================================================
        10. RESET BUTTON
    ====================================================== */}

              <Grid item xs={12} sm={6} md={3} lg={2.4}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",

                    justifyContent: {
                      xs: "stretch",
                      sm: "flex-start",
                    },

                    height: "100%",
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={handleReset}
                    size="small"
                    startIcon={
                      <FontAwesomeIcon
                        icon={faRefresh}
                        style={{
                          fontSize:
                            "12px",
                        }}
                      />
                    }
                    sx={{
                      width: {
                        xs: "100%",
                        sm: "100%",
                      },

                      minWidth: {
                        xs: "100%",
                        sm: "100%",
                      },

                      height: 34,
                      minWidth: 88,
                      px: 1.5,

                      borderRadius: "7px",

                      fontSize: "12px",
                      fontWeight: 600,

                      textTransform: "none",

                      backgroundColor: "#eff6ff", border: "1px solid #bfdbfe", color: "#2563eb",

                      boxShadow:
                        "0 1px 2px rgba(15, 23, 42, 0.05)",

                      transition: "all 0.2s ease",

                      "&:hover": {
                        backgroundColor: "#dbeafe", borderColor: "#93c5fd", color: "#1d4ed8",
                        boxShadow:
                          "0 2px 5px rgba(15, 23, 42, 0.10)",

                        transform: "translateY(-1px)",
                      },

                      "&:active": {
                        backgroundColor: "#cbd5e1",

                        transform: "translateY(0)",
                      },
                    }}
                  >
                    RESET
                  </Button>
                </Box>
              </Grid>
            </Grid>


          </form>
        </div>

        {/* Error Message */}
        {isError && (
          <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>
            <AlertTitle>Error</AlertTitle>
            {error.message}
          </Alert>
        )}

        {/* Data Table Section */}
        <Paper sx={{
          p: isMobile ? 1 : 0,
          borderRadius: 3,
          boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.08)',
          backgroundColor: 'background.paper'
        }} ref={tableRef}>
          {/* Table Header */}


          {/* Data Table */}
          {reportData.length > 0 ? (
            <Box sx={{ width: "100%", overflowX: "auto" }}>
              <MUIDataTable
                data={filteredAndGroupedData}
                dataColumns={columns}
                reportTitle={filters?.billType == 'P' ? "Purchase Report" : filters?.billType == 'S' ? "Sale Report" : filters?.billType == "N" ? "Sale Return Report" : filters?.billType == "T" ? "Purchase Return Report" : "report"}
                orderGroup={groupBy}
                enableCurrency={true}
                filterDate={filters}
                tradeLabel={`Trade: ${getTradeTypeLabel()}`}
                companyName={compName.join(",")}
                hideIfZeroKeys={["TDSAmt", "DiscAmt", "DiscPer", "GSTAmt"]}
                exportColumnKeys={exportColumnKeys}
                exportTemplate={saleRegTemplateColumn}
                templateButton="Sale Register"
                enableHeaderFilter={true}

              />
            </Box>
          ) : (
            !isLoading && (
              <NoDataCard />
            )
          )}
        </Paper>


      </Box>
    </MainContainer>
  );
};

export default TradingReport;
